import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { useReports } from "@domain/admin/hooks";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { gap } from "@ui/styles/utils";
import { ReportView } from "./reportView";

export const ReportTabs: React.FC = () => {
	const { result: reports, loading, fetchMore } = useReports();

	return !reports ? (
		loading ? (
			<ClipLoader color="#000" />
		) : null
	) : (
		<Container>
			<InfiniteScroll loading={loading} onEndReached={fetchMore}>
				{reports.map((report) => (
					<ReportView key={report.id} report={report} />
				))}
			</InfiniteScroll>
		</Container>
	);
};

const Container = styled.div`
	${gap(16)};
	overflow-y: scroll;
	height: 100vh;
`;
